import styled, { css } from "styled-components/native";
import React from "react";
import { useTheme } from "styled-components/native";
import { DefaultTheme } from "styled-components/native";

type ContainerProps = {
  children: React.ReactNode;
  isTablet?: boolean;
  noPadding?: boolean;
  maxWidth?: number;
  applyMaxWidth?: boolean; // To Avoid apply Max Width
};

const Container = ({
  children,
  isTablet,
  noPadding,
  maxWidth,
  applyMaxWidth = true,
}: ContainerProps) => {
  const theme = useTheme();
  return (
    <ParentContainer noPadding={noPadding}>
      <ChildContainer
        isTablet={isTablet}
        maxWidth={maxWidth}
        theme={theme}
        applyMaxWidth={applyMaxWidth}
      >
        {children}
      </ChildContainer>
    </ParentContainer>
  );
};

const ParentContainer = styled.View<{
  noPadding?: boolean;
}>`
  padding-horizontal: ${({ noPadding }: { noPadding?: boolean }) =>
    noPadding ? 0 : 16}px;
  align-items: center;
  overflow: visible;
`;

const ChildContainer = styled.View<{
  isTablet?: boolean;
  maxWidth?: number;
  applyMaxWidth?: boolean;
}>`
  width: 100%;
  ${({
    theme,
    maxWidth,
    applyMaxWidth,
  }: {
    theme: DefaultTheme;
    maxWidth?: number;
    applyMaxWidth?: boolean;
  }) =>
    (theme.isLargeScreen || theme.isTablet) &&
    applyMaxWidth &&
    css`
      max-width: ${maxWidth
        ? `${maxWidth}px`
        : theme.isLargeScreen
        ? "1008px"
        : "750px"};
    `};
`;

export default Container;
